export default "__VITE_ASSET__CwN6QSFe__"